module.exports = __webpack_public_path__ + "static/img/Darcy_Moore_mobile.a3d8e7f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Darcy_Moore_mobile.jpg
// module id = EJ1H
// module chunks = 0